// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Kopie aus kraftbogen/frontend/src/components/OutboxFlusher.tsx (+ Sync danach)
import { useEffect } from "react"
import { flushOutbox } from "@/lib/outbox"
import { syncFromPocketBase } from "@/lib/data"

/** Unsichtbar: Outbox flushen + Sync bei Mount, wenn wieder online und wenn der Tab sichtbar wird. */
export default function OutboxFlusher() {
  useEffect(() => {
    // App-Start + wieder-online erzwingen den Sync; Tab-Wechsel respektiert
    // die Sync-Bremse (5 Min.), damit kurzes Hin-und-Her den Server nicht ärgert
    const run = (erzwingen: boolean) => { void flushOutbox().then(() => syncFromPocketBase(erzwingen)) }
    run(true)
    const onOnline = () => run(true)
    const onVisible = () => { if (document.visibilityState === "visible") run(false) }
    window.addEventListener("online", onOnline)
    document.addEventListener("visibilitychange", onVisible)
    return () => {
      window.removeEventListener("online", onOnline)
      document.removeEventListener("visibilitychange", onVisible)
    }
  }, [])
  return null
}
